module.exports = __webpack_public_path__ + "f0281808fdfdc92fab061c1ed77a67ac.glb";